import Component from '../abstracts/Component';

export default class SizeSelectorComponent extends Component {

  constructor(compEl) {
    super(compEl);
    this.sizes = this.$component.querySelectorAll(this.SELECTORS.size);
    this.isFloatingBar = this.$component.dataset.floatingBar === 'true';
  }

  get COMPONENTNAME() {
    return 'SizeSelectorComponent';
  }

  get SELECTORS() {
    return {
      size: '[data-size] input',
      sizeRadioBox: '[data-size]',
    };
  }

  get CLASSES() {
    return {
      selected: '--selected',
      hidden: '--hidden',
      container: '.js-sizes-container',
      disabled: '--disabled'
    };
  }

  // put classes on selected size
  selectSize(size) {
    let prevSize = this.$component.querySelectorAll(`.${this.CLASSES.selected}`);
    if (prevSize.length) {
      prevSize.forEach(size => size.classList.remove(this.CLASSES.selected));
    }
    const productSizeCode = size.dataset.productCode;
    const sizeInputs = this.$component.querySelectorAll(`[data-product-code='${productSizeCode}']`);
    sizeInputs.forEach(input => input.closest(this.SELECTORS.sizeRadioBox)?.classList?.add(this.CLASSES.selected));
  }

  bindEvents() {
    let ctx = this;
    // pdp CTA
    if (this.sizes.length) {
      this.sizes.forEach(size => {
        size.addEventListener('click', () => {
          // if not available launch notify me event
          if (size.dataset.unavailable === 'true') {
            if (this.$component.dataset.zoomOpen !== 'true') {
              ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.notifyme, {
                productCode: this.$component.dataset.productCode,
                sizeSelected: size.dataset.productCode
              });
              ctx.$emit(ctx.$customEvents.CHANGE_RETURN_STEPS.disabledConfirm, {size: size});
            }
          } else {
            // if available i want to hide the notifyme form
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.notifymeclose, {productCode: this.$component.dataset.productCode});
            ctx.$emit(ctx.$customEvents.CHANGE_RETURN_STEPS.enableConfirm, {size: size});
          }
          // general event
          ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.sizechanged,
            {
              productCode: size.getAttribute('data-product-code'),
              baseProductCode: this.$component.getAttribute('data-product-code'),
              sizeSelected: size.dataset.value,
              unavailable: (size.dataset.unavailable === 'true'),
              size: size
            });
          // reset error
          // find error box
          let sizeErrorBox = document.querySelector('[data-sizes-error=prod_' + this.$component.dataset.productCode + ']');
          if (sizeErrorBox && !sizeErrorBox.classList.contains('--hidden')) {
            sizeErrorBox.classList.add('--hidden');
            sizeErrorBox.innerHTML = '';
          }
        });
      });
    }

    // select a size
    // we need to use an internal event to inform all instances of this class
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({payload}) => {
      ctx.selectSize(payload.size);
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart, ({payload}) => {

      if (payload.baseProductCode === this.$component.dataset.productCode) {
        if (this.sizes.length) {
          this.sizes.forEach(size => {
            size.checked = false;
            size.parentElement.classList.remove(this.CLASSES.selected);
          });
        }

      }
    });

    // Size not selected event
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizerequired, (e) => {

      const productCode = e.payload.getAttribute('data-product-code');
      const errorText = e.payload.getAttribute('data-notification');

      // find error box
      let sizeErrorBox = document.querySelector('[data-sizes-error=prod_' + productCode + ']');
      // put error
      if (sizeErrorBox && sizeErrorBox.classList.contains('--hidden')) {
        sizeErrorBox.classList.remove('--hidden');
        sizeErrorBox.innerHTML = errorText;
      }
    });

    // if size has been selected
    this.$on(this.$customEvents.PRODUCT_EVENTS.addtocart, ({event, payload}) => {
      let btn = payload.button;
      // find error box
      let sizeErrorBox = document.querySelector('[data-sizes-error=prod_' + btn.getAttribute('data-product-code') + ']');
      // remove error
      if (sizeErrorBox && !sizeErrorBox.classList.contains('--hidden')) {
        sizeErrorBox.classList.add('--hidden');
        sizeErrorBox.innerHTML = '';
      }
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.notifymesuccess, () => {
      ctx.sizes?.forEach(size => {
        size.checked = false;
        size.closest(ctx.SELECTORS.sizeRadioBox)?.classList?.remove(ctx.CLASSES.selected)
      });
    });

    this.$on(this.$customEvents.PDP_LAYER_EVENTS.openZoom, () => {
      this.$component.setAttribute('data-zoom-open','true');
    });

    this.$on(this.$customEvents.PDP_LAYER_EVENTS.closeZoom , () => {
      this.$component.setAttribute('data-zoom-open','false');
    });

    this.$on(this.$customEvents.SIZES_EVENTS.disableAll, () => {
      const sizeRadioBoxes = this.$component.querySelectorAll(this.SELECTORS.sizeRadioBox);
      sizeRadioBoxes?.forEach(size => {
        size.classList.add(this.CLASSES.disabled);
      })
    });

    this.$on(this.$customEvents.SIZES_EVENTS.enableAll, () => {
      const sizeRadioBoxes = this.$component.querySelectorAll(this.SELECTORS.sizeRadioBox);
      sizeRadioBoxes?.forEach(size => {
        size.classList.remove(this.CLASSES.disabled);
      })
    });
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
  }
}
